import { Injectable } from '@angular/core';
import { PlatformService } from './device/platform.service';

interface CordovaStatusBar {
  setBackgroundColor(color: string): void;
}

@Injectable({
  providedIn: 'root'
})
export class AppStatusBarService {

  constructor(private platformService: PlatformService) { }

  public initialize(color: string) {
    if (!this.platformService.isNative()) {
      return;
    }

    this.setBackgroundColor(color);
  }

  public setBackgroundColor(color: string) {
    if (!this.platformService.isNative()) {
      return;
    }

    const statusBar = window.statusbar as unknown as CordovaStatusBar;
    if (statusBar && typeof statusBar.setBackgroundColor === 'function') {
      statusBar.setBackgroundColor(color);
    }
  }
}
